import React from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'AppReducer'

import '../styles/Navbar.scss'

import { signOut } from 'util/services/AuthService'
import { NavLink } from 'react-router-dom'

const Navbar: React.FC<{ openSidebar: () => void }> = ({ openSidebar }) => {
  const { logged: user } = useSelector((state: ApplicationState) => state.userReducer)
  const picture = user?.person?.picture || `${process.env.PUBLIC_URL}/img/default-user.png`
  return (
    <div className="row navbar justify-end">
      <span className="row grow hidden-desk">
        <div className="row">
          <span className="button" onClick={openSidebar}>
            <i className="fa fa-bars"></i>
          </span>
          <div className="row grow center-center">
            <img src={`${process.env.PUBLIC_URL}/img/logo-white.png`} height={50} alt="" />
          </div>
        </div>
      </span>
      <NavLink to="/panel/profile" className="row hidden-mobile" style={{ width: 'auto' }}>
        <img src={picture} height={50} className="user-pic" alt="" />
        <span style={{ width: 180 }}>
          <h4>{ user?.person?.firstName }</h4>
          <p className="no-margin text-overflow">{ user?.person.email }</p>
        </span>
      </NavLink>
      <span className="button" onClick={(): void => signOut()}>
        <i className="fa fa-power-off"></i>
      </span>
    </div>
  )
}

export default Navbar
